/*
This script continously loads post as the user scrolls the page. It uses the IntersectionObserver API to detect when the last post is in view. When the last post is in view, it fetches the next page and appends the posts to the page. It then checks if there is a next page and if there is, it continues to observe the last post. If there is no next page, it disconnects the observer. 

Importantly, for this script to work, it requires that each card have the `post` class and that the card container have the `gh-postfeed` class
*/

// Fetch and parse next page
async function getNextPage(url) {
    const response = await fetch(url);

    if (!response.ok) {
        throw new Error(`Failed to fetch page: ${response.status}`);
    }

    const nextPageHtml = await response.text();
    const parser = new DOMParser();
    const parsed = parser.parseFromString(nextPageHtml, 'text/html');

    return {
        posts: [...parsed.querySelectorAll('.post')],
        nextLink: parsed.querySelector('link[rel="next"]')?.getAttribute('href'),
    };
}

export default function infiniteScroll() {
    const feed = document.querySelector('.gh-postfeed');
    let link = document.querySelector('link[rel="next"]')?.getAttribute('href');

    if (!feed || !link || !('IntersectionObserver' in window)) {
        return;
    }

    let isLoading = false;

    const options = {
        // Load the next page shortly before the last card enters the viewport.
        rootMargin: '150px',
    };

    const observer = new IntersectionObserver(async ([entry]) => {
        if (!entry.isIntersecting || isLoading || !link) {
            return;
        }

        isLoading = true;

        try {
            const {posts, nextLink} = await getNextPage(link);

            posts.forEach((post) => feed.append(post));
            link = nextLink;

            if (!link) {
                observer.disconnect();
                return;
            }

            const lastPost = feed.querySelector('.post:last-of-type');

            if (lastPost) {
                observer.observe(lastPost);
            } else {
                observer.disconnect();
            }
        } catch (error) {
            console.error('Unable to load more posts.', error);
        } finally {
            isLoading = false;
        }
    }, options);

    const lastPost = feed.querySelector('.post:last-of-type');

    if (lastPost) {
        observer.observe(lastPost);
    } else {
        observer.disconnect();
    }
}
